export default __webpack_public_path__ + "static/media/Contact Details.9cae8264.svg";